import {ECMPWindow} from "./interface";

export abstract class CMPWindow {
    /* STATIC */

    /* INSTANCE */
    protected constructor(private readonly _id: ECMPWindow) {
    }

    public get id(): ECMPWindow {
        return this._id;
    }

    protected getLangValue<T>(lang: T, defValue: string, key?: string): string {
        let salida: string = '';

        if (key) {
            salida = (lang as any)[key];
        }

        return salida || defValue;
    }

    public abstract close(): void;
}
